const BRANDS = [
  "Maison Vert",
  "Ritz Boulevard",
  "Lumina Clinic",
  "Casa Solé",
  "North Roastery",
  "Atelier Nº8",
  "Verde Spa",
  "The Heron Hotel",
];

export default function SocialProof() {
  return (
    <section
      data-testid="social-proof-section"
      className="py-16 border-y border-[#B1B7AB]/40 bg-[#FFFFFF]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <p className="text-center text-xs sm:text-sm uppercase tracking-[0.22em] text-[#276152] font-semibold">
          Trusted by local venues across MENA &amp; South Asia
        </p>

        <div className="mt-10 overflow-hidden">
          <div className="marquee-track flex items-center gap-20 w-max">
            {[...BRANDS, ...BRANDS].map((b, i) => (
              <span
                key={i}
                className="font-serif text-2xl sm:text-3xl text-[#0D3A35]/55 whitespace-nowrap tracking-tight"
              >
                {b}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
